import { MenuItem, MenuItems } from '@headlessui/react';
import { useAppSelector } from '../../../store';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

type Props = {
  onSelectTheme?: (themeID: string | undefined) => void,
  selectedThemeID?: string
}

export const PlaylistThemeSelector = ({ onSelectTheme, selectedThemeID }: Props) => {

  const themes = useAppSelector(state => state.themes);

  return (
    <MenuItems
      className='fixed mt-8 z-50 bg-white w-52 shadow'
      onClick={(e) => e.stopPropagation()}
      portal={false}
    >
      <MenuItem>
        <div
          className='hover:bg-blue-100 p-2 flex items-center'
          onClick={() => onSelectTheme?.(undefined)}
        >
          <div className='size-4 mr-1'>
            {
              selectedThemeID === undefined && <CheckCircleIcon className='size-4' />
            }
          </div>
          Use global theme
        </div>
      </MenuItem>
      {
        Object.values(themes).map(
          theme => (
            <MenuItem key={theme.id}>
              <div
                className='hover:bg-blue-100 p-2 flex items-center'
                onClick={() => onSelectTheme?.(theme.id)}
              >
                <div className='size-4 mr-1'>
                  {
                    selectedThemeID === theme.id && <CheckCircleIcon className='size-4' />
                  }
                </div>
                {theme.name}
              </div>
            </MenuItem>
          )
        )
      }
    </MenuItems>
  );
};
